import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlogPost = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/blog/${id}`)
      .then((res) => setPost(res.data))
      .catch(() => setPost(null))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-[150px] pb-20 bg-white" data-testid="blog-post">
        <div className="container mx-auto px-4 max-w-3xl">
          <Link to="/insights" className="inline-flex items-center gap-2 text-primary text-sm font-bold uppercase tracking-wider mb-8 hover:underline">
            <ArrowLeft size={16} /> Back to Insights
          </Link>

          {loading ? (
            <p className="text-gray-500">Loading…</p>
          ) : !post ? (
            <p className="text-gray-500">Article not found.</p>
          ) : (
            <article>
              <span className="text-xs uppercase tracking-widest text-gold font-bold">{post.category}</span>
              <h1 className="text-4xl font-display font-bold text-foreground mt-2 mb-4 leading-tight">{post.title}</h1>
              <p className="text-sm text-gray-400 mb-8">By {post.author} · {new Date(post.created_at).toLocaleDateString()}</p>
              {post.image && (
                <img src={post.image} alt={post.title} className="w-full h-[360px] object-cover mb-8 shadow-lg" />
              )}
              <div className="prose max-w-none text-gray-700 leading-relaxed whitespace-pre-wrap text-lg">{post.content}</div>
            </article>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPost;
